import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { theme } from "./theme/theme";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import ContactForm from "./components/ContactForm";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Footer from "./components/Footer";
import PremiumCookieBanner from "./components/PremiumCookieBanner";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box
          sx={{
            minHeight: "100vh",
            backgroundColor: "background.default",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Navbar />
          
          <Box sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={
                <>
                  <Helmet>
                    <title>EDEB Estrichbau | Startseite</title>
                    <meta name="description" content="Professionelle Estrich- und Abbrucharbeiten im Rhein-Main-Gebiet." />
                  </Helmet>
                  <Hero />
                  <About />
                  <Services />
                </>
              } />
              
              <Route path="/kontakt" element={
                <>
                  <Helmet>
                    <title>Kontakt | EDEB Estrichbau</title>
                  </Helmet>
                  <ContactForm />
                </>
              } />

              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
          </Box>
          <Footer />
          <PremiumCookieBanner />
        </Box>
      </Router>
    </ThemeProvider>
  );
}
